import React from 'react'
import styles from './index.module.less'
import classnames from 'classnames'

import Worth from './worth'
import { IWorth, IState } from '@/components/poizon-fission/types'

/**
 * 优惠券：单行展示
 * @param props 多券占据列数
 * @returns React Element
 */
export default function SingleLine(props: { columns: IWorth[] } & IState) {
  const { columns, flow } = props
  const length = columns.length
  return (
    <div
      className={classnames(
        { [styles.oneSingle]: length <= 1, [styles.aHalfSingle]: length > 1 },
        styles[flow]
      )}
    >
      {columns.map((item, index) => (
        <Worth key={index} {...item} flow={flow} />
      ))}
    </div>
  )
}
